import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from "vue";
import apiClient from "@/services/api/apiClient";
import DateFilter from "@/components/lib/dateFilter/DateFilter.vue";
import {DateFilterModel} from "@/services/types/base";
import DurationFilter from "@/components/lib/duration/DurationFilter.vue";
import {showErrorMessage, showInfoMessage} from "@/services/ui/messages";
import {SttFilterTestResponseDto} from "@/services/api/projects/types";
import DropdownSelect, {OptionItem} from "@/components/ui/DropdownSelect.vue";
import {
  getDefaultFilter,
  sttFilter2LocalModel,
  sttFilterLocal2Request,
  SttFilterLocalModel
} from "@/features/project-stt-settings/model";
import {renderDuration} from "../../services/utils";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import {useLightbox} from "@/services/lightbox";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterForm',
  props: {
    projectId: null
  },
  setup(__props: any) {

const props = __props as {
  projectId: number
}



const lightbox = useLightbox()
function showTutorialVideo() {
  lightbox.show('https://ectmprod.storage.yandexcloud.net/video/stt_tutorial.mp4')
}

const isDataLoading = ref(false)
const filterModel = ref<SttFilterLocalModel | null>(null)
const filterWasLoaded = ref(false)

const managersList = ref<OptionItem[]>([])
const sttBalance = ref(0)

//#region TestFilter
const isFilterTestLoading = ref(false)
const filterTestResult = ref<SttFilterTestResponseDto>()

async function testFilter() {
  try {
    if (filterModel.value === null) return
    isFilterTestLoading.value = true
    const filter = sttFilterLocal2Request(filterModel.value)
    filterTestResult.value = await apiClient.projectsApi.testSttFilter(props.projectId, {
      filter
    })
  } catch (e) {
    showErrorMessage(e)
  } finally {
    isFilterTestLoading.value = false
  }
}

//#endregion

//#region Save&Reset
const isFilterSaving = ref(false)

function handleSaveFilter() {
  saveFilter().then(() => showInfoMessage(`Фильтр сохранен. Распознавание по заданному фильтру подключено.`))
}

async function saveFilter() {
  try {
    isFilterSaving.value = true
    const filter = filterModel.value ? sttFilterLocal2Request(filterModel.value) : null
    const resp = await apiClient.projectsApi.setSttFilter(props.projectId, {
      filter
    })
    filterModel.value = sttFilter2LocalModel(resp.filter)
    filterWasLoaded.value = false
  } catch (e) {
    showErrorMessage(e)
  } finally {
    isFilterSaving.value = false
  }
}

function resetFilter() {
  filterModel.value = getDefaultFilter()
}

function deleteFilterAndSave() {
  filterModel.value = null
  saveFilter().then(() => {
    showInfoMessage(`Фильтр удален. Распознавание отключено.`)
  })
}
//#endregion

//#region FilterHandlers
function handleManagersSelectEvent(items: number[]) {
  filterModel.value.managers = items
}

function onCallsDateFilterChange(dates: DateFilterModel) {
  filterModel.value.started = dates
}

function minDurationListener(value: string) {
  filterModel.value.duration.min = value
}

function maxDurationListener(value: string) {
  filterModel.value.duration.max = value
}

//#endregion

function createFilter() {
  filterModel.value = getDefaultFilter()
}

onMounted(async () => {
  try {
    isDataLoading.value = true
    await Promise.all([
      loadManagers(),
      loadFilter(),
      loadBalance()
    ])
  } catch (e) {
    showErrorMessage(e)
  } finally {
    isDataLoading.value = false
  }
})

async function loadManagers() {
  const {items} = await apiClient.projectsApi.getProjectsManagers()
  const managers = items.find(i => i.projectId === props.projectId)?.managers
  managersList.value = managers.map(i => ({
    label: i.name,
    value: i.id
  }))
}

async function loadBalance() {
  const resp = await apiClient.entitiesApi.getSttBalance()
  sttBalance.value = resp.sttBalance
}

async function loadFilter() {
  const resp = await apiClient.projectsApi.getSttFilter(props.projectId)
  filterModel.value = sttFilter2LocalModel(resp.filter)
  if (resp.filter) {
    filterWasLoaded.value = true
  }
}

return { __sfc: true,props, lightbox, showTutorialVideo, isDataLoading, filterModel, filterWasLoaded, managersList, sttBalance, isFilterTestLoading, filterTestResult, testFilter, isFilterSaving, handleSaveFilter, saveFilter, resetFilter, deleteFilterAndSave, handleManagersSelectEvent, onCallsDateFilterChange, minDurationListener, maxDurationListener, createFilter, loadManagers, loadBalance, loadFilter, DateFilter, DurationFilter, DropdownSelect, renderDuration, faCircleInfo }
}

})